// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import govqEntity from './entities/govq.json';
import govqMenu from '../pages/govq/menu.json';
import govqFullForm from '../pages/govq/forms/full.json';
import govqContextForm from '../pages/govq/forms/context.json';
import govqMiniForm from '../pages/govq/forms/mini.json';
import govqLookupForm from '../pages/govq/forms/lookup.json';
import govqTableView from '../pages/govq/views/table.json';
import govqStagesView from '../pages/govq/views/stages.json';
import govqCardsView from '../pages/govq/views/cards.json';
import govqInlineView from '../pages/govq/views/inline.json';
import govqBacklogView from '../pages/govq/views/backlog.json';
import govqSplitView from '../pages/govq/views/split.json';
import govqCalendarView from '../pages/govq/views/calendar.json';
import govqDashboardView from '../pages/govq/views/dashboard.json';

/** Тип запису «Питання до Уряду» зі сторінками пакета: меню, форми та подання з pages/govq/. */
export const govqDefinition: IRecordTypeDefinition = {
  ...govqEntity,
  views: assembleViewSet({
      table: govqTableView,
      stages: govqStagesView,
      cards: govqCardsView,
      inline: govqInlineView,
      backlog: govqBacklogView,
      split: govqSplitView,
      calendar: govqCalendarView,
      dashboard: govqDashboardView,
  }),
  form: govqFullForm,
  forms: { full: govqFullForm, context: govqContextForm, mini: govqMiniForm, lookup: govqLookupForm },
  menu: govqMenu,
} as IRecordTypeDefinition;
